<template>
  <div>
    <v-init-view>
      <router-link slot="right" to="/" class="link">进入网站首页</router-link>
      <div class="login-form-container">
        <div class="form-wrapper">
          <div class="login-container" style="height: 410px">
            <h2 style="font-family: '微软雅黑';">用户登录</h2>
            <el-tabs type="card" @tab-click="login">
              <el-tab-pane label="手机号登录">
                <el-form ref="loginForm">
                  <el-form-item :class="{'is-error':userError}">
                    <el-input v-model="username" maxlength="20" size="" @keyup.enter.native="submitForm" clearable
                              placeholder="用户名称/手机号码">
                      <i slot="prefix" class="icon">
                        <img src="./images/u1014.svg"/>
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item :class="{'is-error':passError}">
                    <el-input v-model="password" type="password" @keyup.enter.native="submitForm" size="" clearable
                              placeholder="输入登录密码">
                      <i slot="prefix" class="icon">
                        <img src="./images/u1009.svg"/>
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <div class="msg" v-if="msg"><i class="el-icon-warning"></i>{{msg}}</div>
                    <el-button class="login-button" :loading="loading" type="primary" @click="submitForm('loginForm')">
                      登录
                    </el-button>
                  </el-form-item>
                </el-form>
                <div class="sub-line">
                  <router-link to="/forgetPassword">忘记密码?</router-link>
                  <router-link to="/register">新用户注册</router-link>
                </div>
              </el-tab-pane>
              <el-tab-pane label="微信登录">
                <div id="login_container" style="margin-top: -15px">
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </v-init-view>
  </div>
</template>

<script>
import MD5 from 'md5.js';
import {setToken, setMember} from "../../utils/auth";
import rsa from '../../components/rsa';

export default {
    data() {
        return {
            userError: false,
            passError: false,
            username: '',
            password: '',
            msg: '',
            loading: false,
            code: '',
            state: ''
        }
    },
    created() {
        if (this.$route.query.code != undefined && this.$route.query.state != undefined){
            this.getMember(this.$route.query.code)
        }
    },
    methods: {
        async getMember(code){
            let data = {
                code: code
            }
            let res = await this.$post('/api/mbPCWxlogin', data);
            if (res.code === '200') {
                setToken(res.token);
                setMember(JSON.stringify(res.member));
                this.$router.push('/')
            } else {
                this.msg = res.message;
            }
        },

        login(tab){
            if (tab.label == '微信登录') {
                var obj = new WxLogin({
                    self_redirect:false,
                    id:"login_container",
                    appid: 'wxeff22d9246d5a949',
                    scope: "snsapi_login",
                    redirect_uri: encodeURIComponent('http://www.e-nongye.com.cn/login'),
                    state: Math.random(),
                    style: "black",
                    href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggLnFyY29kZSB7CiBib3JkZXI6IG5vbmU7CiB3aWR0aDogMjAwcHg7CiBoZWlnaHQ6IDIwMHB4Owp9Ci5pbXBvd2VyQm94IC5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1c19zdWNjICAuc3RhdHVzX3R4dCBoNHtjb2xvcjogIzJlY2M3MX0KLmltcG93ZXJCb3ggLnN0YXR1c19mYWlsIC5zdGF0dXNfdHh0ICBoNHtjb2xvcjogI2U3NGMzY30KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30g'
                });
            }
        },

        async submitForm() {
            this.userError = false;
            this.passError = false;
            if (this.username === "") {
                this.userError = true;
                this.msg = "请输入用户名"
                return;
            }
            if (this.password === "") {
                this.passError = true;
                this.msg = "密码不能为空!"
                return;
            }
            this.loading = true;
            const md5stream = new MD5();
            const passwords = md5stream.update(this.password).digest('hex').toUpperCase();
            let res = await this.$post('/api/eLoginMember', {
                mobile: rsa.encodeRSA(this.username),
                password:rsa.encodeRSA(this.password),
                passwords: passwords
            });
            this.loading = false;
            if (res.code === '200') {
              console.log(res.member)
                setToken(res.token);
                setMember(JSON.stringify(res.member));
                this.$router.push('/')
            } else {
                this.msg = res.message;
            }
            return false;
        }
    }
}
</script>

<style lang="scss">
  .login-form-container {
    height: 600px;
    background: url(./images/u7520_state0.jpg) no-repeat center;
    .form-wrapper {
      padding-top: 50px;
      margin: 0 auto;
      width: 1183px;
      overflow: hidden;
      .login-container {
        padding: 2px 39px 0 41px;
        float: right;
        width: 380px;
        height: 365px;
        background: #fff;
        box-sizing: border-box;
        h2 {
          font-weight: 400;
          font-size: 20px;
          color: #999;
          padding-left: 111px;
          padding-top: 27px;
          height: 76px;
          line-height: 1;
          box-sizing: border-box;
        }
        .login-button {
          margin-top: 30px;
          height: 45px;
          width: 100%;
          border-radius: 0;
          span {
            font-size: 14px;
            color: #fff;
          }
        }
        .el-input__inner {
          height: 50px;
          padding-top: 1px;
          line-height: 48px;
          padding-left: 52.5px;
        }
        .el-form-item {
          position: relative;
          margin-bottom: 20px;
          .msg {
            position: absolute;
            left: 15px;
            top: -4px;
            color: #F04844;
            line-height: 1;
            font-size: 12px;
            i {
              margin-right: 2px;
              color: #F04844;
              font-size: 16px;
            }
          }
        }
        .el-input__prefix {
          display: flex;
          left: 12px;
          align-items: center;
          height: 50px;
          .icon {
            float: left;
            height: 20px;
            img {
              display: block;
              color: #666666;
            }
          }
        }
        .sub-line {
          padding: 0 0 0 1px;
          display: flex;
          justify-content: space-between;
          a {
            font-size: 12px;
            color: #1ABC9C;
          }
        }
      }
    }
  }
</style>
